import {type EventEmitter, type FunctionalComponent, h, type VNode} from '@stencil/core';
import {GuidedProductQuickLink} from '../../models/quick-link';
import type {GuidedV2Emitters} from '../../models/eventNames';
import type {labelProviderInterface} from '../../../LabelProviderInterface';
import {ucOptions} from '../../../result-page/new-result-cards/utils/ucOptions';
import {
  getWcEventData
} from '../../../result-page/new-result-cards/public/product-card/helpers/helpers';
import {GuidedV2LinkAttributeRender} from '../link-attribute-render/link-attribute-render';
import {GuidedV2LinkTagRender} from '../link-tag-render/link-tag-renderer';
import {isMobile} from '../../../../utils/media';

export interface GuidedProductsQuickLinkProps extends GuidedProductQuickLink {
  eventEmitters?: GuidedV2Emitters;
  labelProvider?: labelProviderInterface;
}


export const quickLinkProducts: () => FunctionalComponent<GuidedProductsQuickLinkProps> = () => {

    return (props) => {
        const {
          quickLinkDescription,
          quickLinkCategory,
          quickLinkTitle,
          quickLinkOpenUrl,
          eventEmitters,
          quickLinkBadges,
          quickLinkImage,
          id,
          country,
          language,
          isCTO,
          labelProvider,
          unifiedCheckout
        } = props;


        const emitters = eventEmitters() ?? undefined;

        const clickEmitter = (ev: MouseEvent) => {
            const isAddToCartClick = (ev.target as HTMLAnchorElement).classList?.contains('guided-v2-result-list-section__add-to-cart-button');
            const source = isAddToCartClick ? 'addToCart' : 'mainLink';

            const clickEvent = emitters?.completed?.emit({
              link: quickLinkOpenUrl,
              event: 'guidedSearchClick',
              category: quickLinkCategory,
              source: source,

            });

            if (clickEvent.defaultPrevented) {
              ev.preventDefault();
            }
        };

        const addToCardClickHandler = (e) => {
            e.preventDefault();
            const wcEventData = getWcEventData( ucOptions.ADD_TO_MY_CART, country, language, id);
            emitters.addToMyCart.emit(wcEventData);
            e.target.closest('uiaas-guided-search-v2')?.togglePane(false);
        };

        return <li class="guided-v2-result-list-section__result add-selector-strength">
          <a class="guided-v2-result-list-section__result-link add-selector-strength products" href={quickLinkOpenUrl}
            onClick={clickEmitter}>
            <div class="guided-v2-result-list-section__product-link-container">
              <uiaas-guided-v2-link-image src={quickLinkImage} alt={quickLinkTitle} />
              <div>
                <div class="guided-v2-result-list-section__result-title add-selector-strength">
                  {quickLinkTitle}
                  {quickLinkDescription && <span>- {quickLinkDescription}</span>}
                </div>
                <div class="guided-v2-result-list-section__result-extra add-selector-strength">
                  {quickLinkBadges.attributes.map(attribute => <GuidedV2LinkAttributeRender
                    labelProvider={labelProvider}
                    attribute={attribute}
                  ></GuidedV2LinkAttributeRender>)}
                  {quickLinkBadges.tags.map(tag => <GuidedV2LinkTagRender
                    tag={tag}
                    labelProvider={labelProvider}
                  ></GuidedV2LinkTagRender>)}
                </div>
              </div>
            </div>
            {isCTO === 'false' && unifiedCheckout && <qds-button
              onClick={addToCardClickHandler}
              importance='emphasized'
              size={ isMobile() ? 'small' : 'standard'}
              icon-name='shopping-cart'
              icon-library="default"
              text={
                labelProvider('guided-v2.product-links.add-to-my-cart', 'Add to My Cart')
              }
              data-card-area={ucOptions.ADD_TO_MY_CART}
              href={'javascript: void(0)'}
              class='guided-v2-result-list-section__add-to-cart-button'
            />}
          </a>
        </li> as VNode;
    };
};
